import { render, staticRenderFns } from "./ShogaiRirekishoEdit.vue?vue&type=template&id=a9cf9b0e&scoped=true"
import script from "./ShogaiRirekishoEdit.vue?vue&type=script&lang=js"
export * from "./ShogaiRirekishoEdit.vue?vue&type=script&lang=js"
import style0 from "./ShogaiRirekishoEdit.vue?vue&type=style&index=0&id=a9cf9b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cf9b0e",
  null
  
)

export default component.exports